define('TescoMobile_Sso/js/logout-redirect-mixin',['mage/utils/wrapper'], function (wrapper) {
  'use strict';

  return function (logoutRedirect) {
    return wrapper.wrap(logoutRedirect, function (originalLogoutRedirectFunction, data) {
      originalLogoutRedirectFunction(data);
      window.localStorage.removeItem('tmIsUserUseEmail');
    });
  };
});

